import { render, staticRenderFns } from "./DocumentValuesForm.vue?vue&type=template&id=3e6e6d9a&"
import script from "./DocumentValuesForm.vue?vue&type=script&lang=js&"
export * from "./DocumentValuesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports